import { useMemo } from "react"
import { usePlantReport } from "../scripts/queries/usePlantReportQueries";
import { useGetSavedBonusPercentages } from "../scripts/queries/useBonusQueries";
import { usePlantFilters, searchRows, usePlantTable, sortedRows, exportPlantTables, getWeekThresholds } from "./usePlantTable";

const EMPTY_ARRAY = [];

const PLANT_COLUMNS = [
    {accessorKey: 'fecha', header: 'Fecha', type: 'text', width: 110},
    {accessorKey: 'operador', header: 'Operador', type: 'text', width: 240},
    {accessorKey: 'numOrdem', header: 'OP', type: 'text', width: 100},
    {accessorKey: 'produccion', header: 'Producción', type: 'int', width: 120},
    {accessorKey: 'maquina', header: 'Recurso', type: 'text', width: 150},
    {accessorKey: 'tiempoArreglo', header: 'Tiempo arreglo hr', type: 'dec'},
    {accessorKey: 'tiempoProd', header: 'Tiempo prod hr', type: 'dec'},
    {accessorKey: 'tTotalCoti', header: 'T. total coti', type: 'dec'},
    {accessorKey: 'vcot', header: 'Run speed', type: 'int'},
    {accessorKey: 'hrsArregloReal', header: 'Hrs arreglo real', type: 'dec'},
    {accessorKey: 'hrsProdReal', header: 'Hrs prod real', type: 'dec'},
    {accessorKey: 'hrsImprodReal', header: 'Hrs improd real', type: 'dec'},
    {accessorKey: 'eficienciaMetrics', header: 'Eficiencia', type: 'dec'},
    {accessorKey: 'vep', header: 'Velocidad', type: 'dec'},
    {accessorKey: 'semana', header: 'Semana', type: 'text', width: 90},
    {accessorKey: 'evaluacionHrsProd', header: 'Evaluación hrs prod', type: 'text'},
    {accessorKey: 'aciertoLimpieza', header: 'Acierto limpieza', type: 'dec'},
    {accessorKey: 'arregloReal', header: 'Arreglo real', type: 'dec'},
    {accessorKey: 'produccionStd', header: 'Producción std', type: 'int'},
    {accessorKey: 'pondProd', header: 'Pond. producción std', type: 'pct'},
    {accessorKey: 'pondArreglo', header: 'Pond. arreglo', type: 'pct'},
    {accessorKey: 'eficienciaArreglo', header: 'Eficiencia arreglo', type: 'pct'},
    {accessorKey: 'arregloPonderado', header: 'Arreglo ponderado', type: 'pct'},
    {accessorKey: 'reportedHours', header: 'Total horas Metrics', type: 'dec'},
    {accessorKey: 'sumaPonderacion', header: 'Suma ponderación', type: 'pct'},
    {accessorKey: 'horasNoAplican', header: 'Horas que no aplican', type: 'dec'},
    {accessorKey: 'horas9999', header: '9999', type: 'dec'},
    {accessorKey: 'pondHorasMetrics', header: 'Pond. hrs Metrics', type: 'pct'},
    {accessorKey: 'horasSinOp', header: 'Horas sin OP', type: 'dec'},
    {accessorKey: 'horasTurno', header: 'Horas turno', type: 'dec'},
    {accessorKey: 'horasArregloTotal', header: 'Horas arreglo total', type: 'dec'},
    {accessorKey: 'horasDisponibles', header: 'Hrs turno prod dispo', type: 'dec'},
    {accessorKey: 'horasRelojPond', header: 'Horas reloj ponderado', type: 'dec'},
    {accessorKey: 'diferenciaHoras', header: 'Diferencia en horas', type: 'dec'},
    {accessorKey: 'capturaFila', header: 'Diferencia en horas %', type: 'pct'},
    {accessorKey: 'velocidadCalculada', header: 'Velocidad calculada', type: 'dec'},
    {accessorKey: 'eficienciaCalculada', header: 'Eficiencia calculada', type: 'pct'},
    {accessorKey: 'ponderacion', header: 'Ponderación', type: 'pct'},
    {accessorKey: 'eficienciaPonderada', header: 'Eficiencia ponderada', type: 'pct'},
    {accessorKey: 'eficienciaProduccion', header: 'Eficiencia producción', type: 'pct'},
    {accessorKey: 'eficienciaFila', header: 'Eficiencia trabajador', type: 'pct'},
    {accessorKey: 'rate', header: 'Rate para bono', type: 'pct'},
    {accessorKey: 'bono', header: 'Bono', type: 'pct'},
    {accessorKey: 'nomina', header: 'No. Nómina', type: 'text'},
    {accessorKey: 'turno', header: 'Turno', type: 'text', width: 80},
    {accessorKey: 'trabajosPorDia', header: 'Trabajos por día', type: 'int'},
    {accessorKey: 'horasMaqNoTripuladas', header: 'Hrs máquina no tripuladas', type: 'dec', width: 150},
    {accessorKey: 'ponderacionMaquina', header: 'Pond. máquina', type: 'pct'},
    {accessorKey: 'maquinasPorDia', header: 'Máquinas por día', type: 'int'},
    {accessorKey: 'horasMaqNoTripPond', header: 'Hrs máq no trip ponde', type: 'dec'},
    {accessorKey: 'totalHorasMaq', header: 'Total horas máq', type: 'dec'},
    {accessorKey: 'velocidadMaq', header: 'Velocidad máq', type: 'dec'},
    {accessorKey: 'eficienciaMaq', header: 'Eficiencia máq', type: 'pct'},
    {accessorKey: 'eficienciaMaqPond', header: 'Máq efi pond', type: 'pct'},
    {accessorKey: 'horasImprodMaq', header: 'Hrs impro máquina', type: 'dec'},
    {accessorKey: 'eficienciaSumaMaq', header: 'Eficiencia sum máq', type: 'pct'},
    {accessorKey: 'horasRelojRegistro', header: 'Total horas reloj registro', type: 'dec', width: 150},
    {accessorKey: 'area', header: 'Área', type: 'text', width: 110},
];

//Data eficiencia": one row per Metrics row of a day. 
export const usePlantReportNormalizer = (active = true) => {
    const filters = usePlantFilters('PLANT_REPORT_FILTERS');
    const {fecha, search, sorting, setSorting} = filters;

    const {data: report, refetch: fetchData, isFetching, isLoading: loading} = usePlantReport(fecha, active);
    const data = report?.filas ?? EMPTY_ARRAY;
    const {data: percentages = EMPTY_ARRAY} = useGetSavedBonusPercentages();

    const processedData = useMemo(() => {
        const {rates} = getWeekThresholds(percentages, fecha);

        const operatorEfficiency = {};
        data.forEach(row => {
            operatorEfficiency[row.operador] = (operatorEfficiency[row.operador] ?? 0) + row.eficienciaPonderada;
        });

        return data.map(row => {
            const rate = rates[row.maquina] != null ? rates[row.maquina] / 100 : null;
            return {...row, rate, bono: rate != null ? (operatorEfficiency[row.operador] >= rate ? 1 : 0) : null};
        });
    }, [data, percentages, fecha]);

    const filteredData = useMemo(() => searchRows(processedData, search, ['operador', 'maquina', 'nomina', 'numOrdem']), [processedData, search]);
    const {columns, table} = usePlantTable(PLANT_COLUMNS, filteredData, sorting, setSorting);

    //A 0% bonus in red, as in the table
    const exportCSV = () => exportPlantTables(`Reporte_Eficiencia_Planta_${fecha}.xlsx`, [{columns, rows: sortedRows(table)}],
        (row, col) => col.accessorKey === 'bono' && row.bono === 0 ? {fill: {patternType: 'solid', fgColor: {rgb: 'FFC7CE'}}} : undefined);

    return {...filters, table, loading, isFetching, fetchData, exportCSV};
}